import { Loader } from 'src/design/atoms/Loader';
import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useChangeType } from 'src/api/queries/changeTypes/useChangeTypes';
import { Header } from 'src/design/organisms/Header';
import { ChangeTypeForm } from 'src/routes/Settings/ChangeTypes/components/ChangeTypeForm';

export const UpdateChangeType: React.FC = () => {
  const params = useParams<{ id: string }>();
  const { data: changeType, isLoading } = useChangeType(params.id);

  const title = isLoading ? 'Loading...' : changeType?.name || params.id;

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'Change Types', href: '/settings/change-types' },
            { text: title ?? '' },
          ],
        }}
        title={title ?? ''}
        helpText="Update this change type's name, sort order, and active state."
      />
      {isLoading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : changeType ? (
        <ChangeTypeForm initialValues={changeType} />
      ) : (
        <Text c="dimmed">Change type not found.</Text>
      )}
    </>
  );
};
